const Uzbek = () => (
   <svg
      height='24'
      style={{ enableBackground: 'new 0 0 512 512' }}
      viewBox='0 0 512 512'
      width='24'
      x='0px'
      xmlSpace='preserve'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      y='0px'
   >
      <path
         style={{ fill: '#F0F0F0' }}
         d='M12.088,178.088C4.246,202.656-0.001,228.829,0,255.998c-0.001,27.17,4.247,53.345,12.089,77.913 l243.911,11.132l243.911-11.13c7.841-24.569,12.09-50.745,12.09-77.913c-0.001-27.17-4.248-53.344-12.09-77.913l-243.911-11.13 L12.088,178.088z'
      />
      <g>
         <path
            style={{ fill: '#D80027' }}
            d='M499.91,178.088l-243.911-11.13l-243.912,11.13c-2.324,7.284-4.325,14.711-6.002,22.261h499.824 C504.234,192.798,502.234,185.37,499.91,178.088z'
         />
         <path
            style={{ fill: '#D80027' }}
            d='M6.088,311.651c1.675,7.55,3.676,14.976,6,22.26l0.024,0.001l243.886,11.13l243.911-11.13 c2.324-7.284,4.325-14.711,6.001-22.261H6.088z'
         />
      </g>
      <path
         style={{ fill: '#6DA544' }}
         d='M255.999,511.999c114.216,0,210.946-74.803,243.911-178.087H12.089 C45.054,437.195,141.786,511.999,255.999,511.999z'
      />
      <path
         style={{ fill: '#338AF3' }}
         d='M255.999,0.001C141.785,0.002,45.055,74.805,12.088,178.088l487.821,0.001 C466.946,74.804,370.215,0,255.999,0.001z'
      />
      <g>
         <path
            style={{ fill: '#F0F0F0' }}
            d='M116.986,105.74c0-23.977,16.851-44.007,39.354-48.921c-3.458-0.756-7.047-1.165-10.733-1.165 c-27.662,0-50.087,22.424-50.087,50.087s22.423,50.087,50.087,50.087c3.686,0,7.274-0.41,10.733-1.165 C133.838,149.747,116.986,129.717,116.986,105.74z'
         />
         <polygon
            style={{ fill: '#F0F0F0' }}
            points='185.944,128.507 189.334,138.942 200.306,138.942 191.43,145.392 194.82,155.827 185.944,149.378 177.066,155.827 180.457,145.392 171.58,138.942 182.552,138.942 	'
         />
         <polygon
            style={{ fill: '#F0F0F0' }}
            points='220.964,128.507 224.355,138.942 235.327,138.942 226.45,145.392 229.841,155.827 220.964,149.378 212.087,155.827 215.478,145.392 206.602,138.942 217.573,138.942 	'
         />
         <polygon
            style={{ fill: '#F0F0F0' }}
            points='255.985,128.507 259.375,138.942 270.348,138.942 261.471,145.392 264.861,155.827 255.985,149.378 247.107,155.827 250.499,145.392 241.621,138.942 252.594,138.942 	'
         />
         <polygon
            style={{ fill: '#F0F0F0' }}
            points='291.006,128.507 294.397,138.942 305.368,138.942 296.492,145.392 299.883,155.827 291.006,149.378 282.128,155.827 285.52,145.392 276.642,138.942 287.614,138.942 	'
         />
         <polygon
            style={{ fill: '#F0F0F0' }}
            points='326.026,128.507 329.417,138.942 340.389,138.942 331.513,145.392 334.904,155.827 326.026,149.378 317.149,155.827 320.54,145.392 311.664,138.942 322.635,138.942 	'
         />
         <polygon
            style={{ fill: '#F0F0F0' }}
            points='220.964,92.08 224.355,102.514 235.327,102.514 226.45,108.965 229.841,119.399 220.964,112.95 212.087,119.399 215.478,108.965 206.602,102.514 217.573,102.514 	'
         />
         <polygon
            style={{ fill: '#F0F0F0' }}
            points='255.985,92.08 259.375,102.514 270.348,102.514 261.471,108.965 264.861,119.399 255.985,112.95 247.107,119.399 250.499,108.965 241.621,102.514 252.594,102.514 	'
         />
         <polygon
            style={{ fill: '#F0F0F0' }}
            points='291.006,92.08 294.397,102.514 305.368,102.514 296.492,108.965 299.883,119.399 291.006,112.95 282.128,119.399 285.52,108.965 276.642,102.514 287.614,102.514 	'
         />
         <polygon
            style={{ fill: '#F0F0F0' }}
            points='326.026,92.08 329.417,102.514 340.389,102.514 331.513,108.965 334.904,119.399 326.026,112.95 317.149,119.399 320.54,108.965 311.664,102.514 322.635,102.514 	'
         />
         <polygon
            style={{ fill: '#F0F0F0' }}
            points='255.985,55.652 259.375,66.088 270.348,66.088 261.471,72.537 264.861,82.973 255.985,76.524 247.107,82.973 250.499,72.537 241.621,66.088 252.594,66.088 	'
         />
         <polygon
            style={{ fill: '#F0F0F0' }}
            points='291.006,55.652 294.397,66.088 305.368,66.088 296.492,72.537 299.883,82.973 291.006,76.524 282.128,82.973 285.52,72.537 276.642,66.088 287.614,66.088 	'
         />
         <polygon
            style={{ fill: '#F0F0F0' }}
            points='326.026,55.652 329.417,66.088 340.389,66.088 331.513,72.537 334.904,82.973 326.026,76.524 317.149,82.973 320.54,72.537 311.664,66.088 322.635,66.088 	'
         />
      </g>
   </svg>
);
export default Uzbek;
